<template>
  <div>
    <div
      v-if="loading"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <v-row v-if="enableTable">
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
          >
            <thead>
              <tr>
                <th
                  v-for="(h, index) in headers"
                  id="dadoMovimentacaoHeader"
                  :key="'head-' + index"
                  :class="h.class"
                  :style="{ textAlign: center }"
                  @click="mudarOrdenacao(h.value)"
                >
                  {{ h.text }}
                  <v-icon small>
                    {{ ordenarDados === h.value ? (ordenacaoDadosDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                  </v-icon>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in faturamento"
                :key="'row-' + index"
              >
                <td
                  v-for="(h, hIndex) in headers"
                  id="dadoMovimentacao"
                  :key="'cell-' + index + '-' + hIndex"
                  :style="{ textAlign: h.align }"
                >
                  {{ item[h.value] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
  import Produto from '../../../../../services/analiseproduto'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'DashboardTableFaturamentoClassificacaoMes',
    emits: ['setDadosFaturamentoLinha'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      empresa: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      headers: [],
      faturamento: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      minWidth: 1380,
      width: window.innerWidth,
      enableTable: false,
      center: 'center',
      ordenarDados: '',
      ordenacaoDadosDecrescente: false,
    }),

    created () {
      eventEmit.$on('set-update-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-update-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedores, areas, redes, supervisores, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.empresa = select
        this.vendedor = vendedores
        this.area = areas
        this.rede = redes
        this.supervisor = supervisores
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.headers = []
        this.faturamento = []
        this.enableTable = false

        this.showTableFaturamentoClassificacaoMes()
      },

      async showTableFaturamentoClassificacaoMes () {
        this.loading = true

        await Produto.showFaturamentoGrupoMes(this.primeiroDia, this.ultimoDia, this.empresa, this.vendedor, this.area, this.rede, this.supervisor, localStorage.tokencontrato, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.enableTable = true

            this.headers = resposta.data.headers

            this.faturamento = resposta.data.dadosExibicao

            eventEmit.$emit('set-dados-faturamento-linha', this.headers, this.faturamento)
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.enableTable = false

            this.headers = []
            this.faturamento = []

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      mudarOrdenacao (campo) {
        if (this.ordenarDados === campo) {
          this.ordenacaoDadosDecrescente = !this.ordenacaoDadosDecrescente
        } else {
          this.ordenarDados = campo
          this.ordenacaoDadosDecrescente = false
        }

        this.buscarDadosOrdenados()
      },

      buscarDadosOrdenados () {
        const dados = [...this.faturamento]

        const total = dados.pop()

        dados.sort((a, b) => {
          const valorA = this.obterValorOrdenacao(a[this.ordenarDados])
          const valorB = this.obterValorOrdenacao(b[this.ordenarDados])

          let resultado = 0

          if (valorA < valorB) resultado = -1
          if (valorA > valorB) resultado = 1

          return this.ordenacaoDadosDecrescente ? -resultado : resultado
        })

        dados.push(total)

        this.faturamento = dados
      },

      obterValorOrdenacao (valor) {
        if (valor == null) return ''

        if (typeof valor === 'string') {
          if (valor.includes('R$')) {
            return Number(
              valor.replace(/\s/g, '').replace('R$', '').replace(/\./g, '').replace(',', '.'),
            )
          }

          if (valor.includes('%')) {
            return Number(valor.replace('%', '').replace(',', '.'))
          }

          return valor.toLowerCase()
        }

        return valor
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 500px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #tableFatClassificacaoMes {
      width: 100% !important;
    }

    #idTable {
      max-height: 500px;
      max-width: 360px !important;
      margin: 0 0 0 0rem;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  /* @media screen
  and (min-width: 1380px) {
    #tableFatClassificacaoMes {
      height: 500px;
    }
  } */
</style>

<style lang="sass">
  #textoKgFaturado
    margin: -1.3rem 0 0 4rem

  .large-screen .v-data-table
    height: 500px

</style>
